import type { NewsletterContent } from '@/core/types';

import { Newsletter } from '@/containers/blocks/forms';

export default function generate({
  content,
  className,
}: {
  content: NewsletterContent;
  className?: string;
}) {
  return <Newsletter title={content.title} subTitle={content.subtitle} className={className} />;
}
